import React from 'react';
import { OfflineEpisode } from '../services/animeOfflineDB';
import { useBodyScrollLock } from '../utils/scrollLock';
import { OfflineEpisodeList } from './OfflineEpisodeList';
import { X, Library } from 'lucide-react';

interface OfflineLibraryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onWatched?: (episode: OfflineEpisode) => void;
}

/** Every episode downloaded into the app, across all shows */
export const OfflineLibraryModal: React.FC<OfflineLibraryModalProps> = ({ isOpen, onClose, onWatched }) => {
  useBodyScrollLock(isOpen);
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-2.5 sm:p-4 safe-area-modal"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-slate-900 border border-slate-700/90 rounded-2xl sm:rounded-3xl max-w-3xl w-full max-h-[90vh] supports-[height:100dvh]:max-h-[90dvh] flex flex-col shadow-2xl overflow-hidden"
      >
        <div className="bg-slate-800/90 px-5 py-3.5 border-b border-slate-700/80 flex items-center justify-between shrink-0">
          <div className="flex items-center gap-2">
            <Library className="w-5 h-5 text-emerald-400" />
            <h3 className="text-base sm:text-lg font-bold text-white">คลังดาวน์โหลด (ดูในแอป)</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-slate-400 hover:text-white p-1 rounded-lg hover:bg-slate-700 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 sm:p-5 flex-1 overflow-y-auto overscroll-contain">
          <OfflineEpisodeList onWatched={onWatched} />
        </div>
      </div>
    </div>
  );
};
